class LoadingElement extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <p class="loading"></p>
      `;
  }
}

customElements.define('loading-element', LoadingElement);
